/**
 * Converts a Hungarian city name to a URL-friendly slug.
 * E.g., "Dunaújváros" → "dunaujvaros", "Székesfehérvár" → "szekesfehervar"
 */
export function cityNameToSlug(name: string): string {
  const hungarianMap: Record<string, string> = {
    á: "a", é: "e", í: "i", ó: "o", ö: "o", ő: "o",
    ú: "u", ü: "u", ű: "u",
    Á: "a", É: "e", Í: "i", Ó: "o", Ö: "o", Ő: "o",
    Ú: "u", Ü: "u", Ű: "u",
  };

  return name
    .split("")
    .map((ch) => hungarianMap[ch] ?? ch)
    .join("")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Finds the original city name from a slug by comparing against available cities.
 */
export function slugToCityName(slug: string, cities: string[]): string | null {
  for (const city of cities) {
    if (cityNameToSlug(city) === slug) return city;
  }
  return null;
}
